export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: 'FightCore | Super Smash Bros. Melee Frame Data',
  shortName: 'FightCore',
  description: '',
  links: {
    github: 'https://github.com/fightcore',
    twitter: 'https://twitter.com/fightcoregg',
    discord: 'https://discord.fightcore.gg/',
  },
};
